export default __webpack_public_path__ + "static/media/705.9614f563.png";